import * as Types from '../actions';

export function showNotification(payload: {
  message: string;
}): Types.ShowNotificationAction {
  return { type: Types.NOTIFICATION_SHOW, payload };
}

export type ShowNotificationActionCreator = typeof showNotification;

export function hideNotification(): Types.HideNotificationAction {
  return { type: Types.NOTIFICATION_HIDE };
}

export type HideNotificationActionCreator = typeof hideNotification;
